import { autoUpdate, size, useFloating } from '@floating-ui/react'
import classnames from 'classnames'
import React, { useEffect } from 'react'
import { mergeRefs } from 'react-merge-refs'

import styles from './FieldDropdown.module.scss'

type FieldDropdownProps = {
  open: boolean
  anchor: HTMLElement | null | undefined
} & React.HTMLAttributes<HTMLDivElement>

export default React.memo(
  React.forwardRef<HTMLDivElement, FieldDropdownProps>(function FieldDropdown(
    { open, anchor, children, className, ...htmlProps },
    ref
  ) {
    const { refs, floatingStyles } = useFloating({
      placement: 'bottom',
      whileElementsMounted: autoUpdate,
      middleware: [
        size({
          padding: { bottom: 20 },
          apply({ availableHeight, elements }) {
            elements.floating.style.maxHeight = `${availableHeight}px`
          },
        }),
      ],
    })

    useEffect(() => {
      refs.setReference(anchor || null)
    }, [anchor])

    if (!open) {
      return null
    }

    return (
      <div
        ref={mergeRefs([ref, refs.setFloating])}
        className={classnames(styles.FieldDropdown, className)}
        {...htmlProps}
        style={floatingStyles}
      >
        {children}
      </div>
    )
  })
)
